/* eslint-disable max-len */

const messages = {
  fr: {
    home: {
      title: 'Porsche Moment Wall',

      subTitle: 'Imprimez vos meilleurs moments Porsche en mode Pola.',

      btnText: 'On y va !',

      phoneSwitch:
        'Pour une qualité d’image optimale, continuez sur votre <b>smartphone</b>. Rendez-vous sur <b>https://porschemomentwall.piix.me</b> .<br> Ou scannez le QR code ci-dessous.',
      desktopContinue: 'Je rencontre des problèmes avec mon smartphone. Je continue avec mon ordinateur',

      languageSwitch: 'NL',
      languageSwitchLocale: 'nl',
    },

    themes: {
      title: 'Sélectionnez votre pola préféré !',
      text: '',
    },

    theme: {
      title: '',
      btnText: 'Prenez votre photo !',
      sending: "Envoi de l'image ...",
      processing: "Traitement de l'image ...",
      notGood: 'Pas satisfait ?',
      tryAgain: 'Essayez à nouveau',
      continue: 'Continuer',
      fileUpload: 'Charger une photo (format carré)',
    },

    form: {
      title: 'Personnalisez votre photo',
      subtitle: 'Introduisez le texte de personnalisation de votre photo',
      textLabel: '',
      btnText: 'Je valide !',
    },

    qr: {
      title: 'Imprimez votre photo',
      subtitle: "Pour imprimer votre photo, scannez ce QR-code sur la borne d'impression",
    },

    footer: {
      poweredBy: 'Powered by Priintr',
    },

    cameraHelp: {
      link: '',
      text:
        "Désolé, nous ne pouvons pas accéder à votre caméra. Assurez-vous que votre navigateur a l'autorisation d'accéder à votre caméra et d'actualiser cette page.",
      ios: '',
      android: '',
    },

    validation: {
      portrait: 'Pour une photo parfaite, veuillez tenir votre téléphone à la verticale.',
      landscape: "Pour une photo parfaite, veuillez tenir votre téléphone à l'horizontal.",
    },
  },

  nl: {
    home: {
      title: 'Porsche Moment Wall',

      subTitle: 'Druk je favoriete Porsche-momenten af in de Pola-mode.',

      btnText: 'Let’s go !',

      phoneSwitch:
        'Schakel naar je smartphone voor een optimale ervaring. Ga naar <b>https://porschemomentwall.piix.me</b> via je telefoon of flash de QR-code hieronder.',
      desktopContinue: 'Nee bedankt, ik ga verder op mijn computer.',

      languageSwitch: 'FR',
      languageSwitchLocale: 'fr',
    },

    themes: {
      title: '',
      text: '',
    },

    theme: {
      title: '',
      btnText: 'Neem een foto!',
      sending: 'Beeld verzending...',
      processing: 'Beeld verwerking...',
      notGood: 'Ben je niet tevreden?',
      tryAgain: 'Probeer het opnieuw!',
      continue: 'Verder gaan',
      fileUpload: 'Upload een foto (vierkant formaat)',
    },

    form: {
      title: 'Personaliseer je foto',
      subtitle: 'Voer de tekst in om je foto te personaliseren',
      textLabel: '',
      btnText: 'Ik valideer !',
    },

    thanks: {
      topText: 'Bedankt voor je deelname!',
      text: 'De foto komt zo in de mailbox.',
      download: 'Download de foto',
    },

    qr: {
      title: 'Je foto afdrukken',
      subtitle: 'Om je foto af te drukken, scan deze QR-code op de print desk',
    },

    footer: {
      poweredBy: 'Powered by Priintr',
    },

    cameraHelp: {
      link: '',
      text:
        'Sorry, we hebben geen toegang tot uw camera. Zorg ervoor dat uw browser toestemming heeft om toegang te krijgen tot uw camera en vernieuw deze pagina.',
      ios: '',
      android: '',
    },

    validation: {
      portrait: 'Voor een perfect beeld houd jouw telefoon horizontaal.',
      landscape: 'Voor een perfect beeld houd jouw telefoon verticaal.',
    },
  },

  fallbackLocale: 'fr',
  websiteTitle: 'Porsche Moment Wall',

  domain: 'porschemomentwall.piix.me',
};

module.exports = messages;
